// Sorts by the orden column like the server: items without orden go last and
// ties are broken by id, so the order is always the same.
export const compararPorOrden = (a, b, idKey) => {
  const ordenA = parseFloat(a.orden);
  const ordenB = parseFloat(b.orden);
  const sinOrdenA = isNaN(ordenA);
  const sinOrdenB = isNaN(ordenB);
  if (sinOrdenA !== sinOrdenB) return sinOrdenA ? 1 : -1;
  if (!sinOrdenA && ordenA !== ordenB) return ordenA - ordenB;
  return String(a[idKey]).localeCompare(String(b[idKey]), undefined, {
    numeric: true,
  });
};

// AvancePickerMobile reports the change (delta); ponderación fields store the
// resulting value, never below 0.
export const aplicarDelta = (actual, delta) =>
  Math.max(0, Math.round(((parseFloat(actual) || 0) + delta) * 100) / 100);
